import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createExpenseFromReceipt } from '../api/expensesApi';

// Scan-driven create flow. Mirrors useCreateExpense — SignalR's
// UpdateExpenseTable + UpdateReceiptTable broadcasts handle cache
// invalidation, so no optimistic write here.
export default function useCreateExpenseFromReceipt() {
    return useMutation({
        mutationFn: createExpenseFromReceipt,
        onSuccess: () => toast.success('Expense created'),
        onError: (err) => toast.error(err?.message ?? 'Failed to create expense'),
    });
}
